// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 10/20/2023 7:16:19 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

import { Post } from 'services/httpClient';

/* eslint-disable @typescript-eslint/no-empty-interface */

export enum GetEmployeeListsEnum {
  takeLessThan1 = 0,
  takeGraterThan100 = 1,
  companyIdIsRequired = 2,
}

export enum GetJobListsEnum {
  takeLessThan1 = 0,
  takeGraterThan100 = 1,
  companyIdIsRequired = 2,
}

export enum AddTimeEmployeeEnum {
  companyIdIsRequired = 0,
  employeeIdIsRequired = 1,
}

export enum TimeSyncEnum {
  tokenExpired = 0,
}

export interface ConnectionInitialisationRequestInterface {
  companyId: number;
}

export interface ConnectionInitialisationResponseInterface {
  connectionStatus: string;
  authorizationUri: string;
  isEmployeeMapped: string;
  lastImportedOn?: string;
  lastMappedOn?: string;
  connectionStatusType?: string;
  validationResults: ValidationResultsInterface;
}

export interface GetEmployeeListsRequestInterface {
  companyId: number;
  skip: number;
  take: number;
}

export interface GetEmployeeListsResponseInterface {
  totalCount: number;
  isEmployeeMapped: string;
  mappedEmployeeList: Array<MappedEmployeeInterface>;
  timeEmployeeList: Array<EmployeeInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistEmployeeMapRequestInterface {
  companyId: number;
  mappedEmployeeList: Array<MappedEmployeeInterface>;
  validationOnly?: boolean;
}

export interface PersistEmployeeMapResponseInterface {
  mappedEmployeeList: Array<MappedEmployeeInterface>;
  validationResults: ValidationResultsInterface;
  employeeToUpdateAmount: number;
  updatedEmployeeAmount: number;
  timeEmployeeList: Array<EmployeeInterface>;
}

export interface GetJobListsRequestInterface {
  companyId: number;
  skip: number;
  take: number;
}

export interface GetJobListsResponseInterface {
  totalCount: number;
  isJobMapped: string;
  mappedJobList: Array<MappedJobInterface>;
  timeJobList: Array<JobInterface>;
  validationResults: ValidationResultsInterface;
}

export interface JobInterface {
  id: number;
  jobName: string;
}

export interface MappedJobInterface {
  id: number;
  jobName: string;
  employeeFullName: string;
  associatedTimeJobId?: number;
}

export interface PersistJobMapRequestInterface {
  companyId: number;
  mappedJobList: Array<MappedJobInterface>;
}

export interface PersistJobMapResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DisconnectTimeRequestInterface {
  companyId: number;
}

export interface DisconnectTimeResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ConnectTimeRequestInterface {
  authorizationCode: string;
  companyId: number;
}

export interface ConnectTimeResponseInterface {
  validationResults: ValidationResultsInterface;
}

export enum MappedEmployeeActionResultTypeEnum {
  notChanged = 0,
  deleteMappingError = 1,
  updateMappingError = 2,
  createMappingError = 3,
  deleteMappingValidated = 4,
  updateMappingValidated = 5,
  createMappingValidated = 6,
  deletedMapping = 7,
  updatedMapping = 8,
  createdMapping = 9,
}

export enum MappedEmployeeStatusTypeEnum {
  notDefined = 0,
  newNotMapped = 1,
  notMapped = 2,
  mapped = 3,
}

export interface MappedEmployeeInterface {
  id: number;
  fullName: string;
  email: string;
  associatedTimeEmployeeId?: number;
  removeMapping: boolean;
  addMapping: boolean;
  doNotMap: boolean;
  validationResults: ValidationResultsInterface;
  mappedEmployeeActionResultType: MappedEmployeeActionResultTypeEnum;
  mappedEmployeeStatusType: MappedEmployeeStatusTypeEnum;
  persistEmployeeMapResponse: PersistEmployeeMapResponseInterface;
}

export interface EmployeeInterface {
  id: number;
  fullName: string;
  email: string;
}

export interface AddTimeEmployeeRequestInterface {
  companyId: number;
  employeeId: number;
}

export interface AddTimeEmployeeResponseInterface {
  employee?: EmployeeInterface;
  validationResults: ValidationResultsInterface;
}

export interface ImportTimeHoursRequestInterface {
  companyId: number;
  cycleBegining: string;
  cycleEnd: string;
  payPeriodId: number;
}

export interface ImportedEmployeeHoursInterface {
  employeeId: number;
  employeeNumber: string;
  employeeFullName: string;
  dateTimeIn: string;
  dateTimeOut: string;
  jobNumber: string;
  totalHours: number;
  regularHours: number;
  overTimeHours: number;
  doubleTimeHours: number;
  importTimeHoursResponse: ImportTimeHoursResponseInterface;
}

export interface ImportTimeHoursResponseInterface {
  importedHoursList: Array<ImportedHoursInterface>;
  importedEmployeeHoursList: Array<ImportedEmployeeHoursInterface>;
  validationResults: ValidationResultsInterface;
}

export interface ImportedHoursInterface {
  jobNumber: string;
  employeeNumber: string;
  regularHours: string;
  overTimeHours: string;
  doubleOvertimeHours: string;
  approvalStatus: string;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

export class TimeIntegrationAccessService {
  connectionInitialisation(
    request: ConnectionInitialisationRequestInterface
  ): Promise<ConnectionInitialisationResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/connectionInitialisation', request);
  }

  getEmployeeLists(request: GetEmployeeListsRequestInterface): Promise<GetEmployeeListsResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/getEmployeeLists', request);
  }

  persistEmployeeMap(request: PersistEmployeeMapRequestInterface): Promise<PersistEmployeeMapResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/persistEmployeeMap', request);
  }

  getJobLists(request: GetJobListsRequestInterface): Promise<GetJobListsResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/getJobLists', request);
  }

  persistJobMap(request: PersistJobMapRequestInterface): Promise<PersistJobMapResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/persistJobMap', request);
  }

  disconnectTime(request: DisconnectTimeRequestInterface): Promise<DisconnectTimeResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/disconnectTime', request);
  }

  connectTime(request: ConnectTimeRequestInterface): Promise<ConnectTimeResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/connectTime', request);
  }

  addTimeEmployee(request: AddTimeEmployeeRequestInterface): Promise<AddTimeEmployeeResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/addTimeEmployee', request);
  }

  importTimeHours(request: ImportTimeHoursRequestInterface): Promise<ImportTimeHoursResponseInterface> {
    return Post('/PayrollTimeIntegrationAccess/importTimeHours', request);
  }
}

export default new TimeIntegrationAccessService();
